import {computed}  from 'mobx';
import CalendarEvent from './CalendarEvent';

class HolidayEvent extends CalendarEvent {
  @computed get backgroundColor() {
    return '#00B7B3';
  }

  @computed get textColor() {
    return '#FFFFFF';
  }

  @computed get borderColor() {
    return '#00B7B3';
  }
}

export default HolidayEvent;
